export enum BmarkFixingType {
  ACTIVE,
  RECENT,
  ALL,
}

export namespace BmarkFixingType {
  let elements = [BmarkFixingType.ACTIVE, BmarkFixingType.RECENT, BmarkFixingType.ALL];
  let alias = "com.bcdfx.model.BmarkFixingType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
